import * as React from 'react';
import PropTypes from 'prop-types';
import './TimePill.scss';

export const TimePill = ({ value, callback }) => {
  return (
    <div className='TimePill' onClick={callback}>
      <span className='TimePill-value noSelect' >{value}</span>
    </div>
  );
};

TimePill.propTypes = {
  value: PropTypes.string,
  callback: PropTypes.func,
};
